import { configureStore } from '@reduxjs/toolkit';
import configReducer from './configSlice';
import trainingReducer from './trainingSlice';
import adminReducer from './adminSlice';
import apiReducer from './apiSlice';
import creditsReducer from './creditSlice';
import draftingReducer from './draftingSlice';

export const store = configureStore({
  reducer: {
    config: configReducer,
    training: trainingReducer,
    admin: adminReducer,
    api: apiReducer,
    credits: creditsReducer,
    drafting: draftingReducer,
  },
});

export type AppDispatch = typeof store.dispatch;